var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMainEmail = function SvgMainEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "11px",
    viewBox: "0 0 10 11",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webphone_new_login_page",
    transform: "translate(-56.000000, -429.000000)",
    fill: "#CDD9E5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(32.000000, 412.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(24.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37720834,9.88588254 C5.9455674,9.88588254 5.47716059,9.87919784 4.98694891,9.87919784 C4.54225688,9.87919784 4.11491326,9.88397262 3.71701417,9.88397262 C2.20181442,9.88397262 1.11411746,9.81457902 1.11411746,9.14642687 C1.11411746,7.6068757 2.84800255,5.84497851 4.98694891,5.84497851 C7.12589527,5.84497851 8.85993952,7.6068757 8.85993952,9.14642687 C8.85993952,9.80980423 7.82922171,9.88588254 6.37720834,9.88588254 M4.98694891,1.11411746 C5.96323412,1.11411746 6.75744071,1.90848321 6.75744071,2.88460926 C6.75744071,3.86089448 5.96323412,4.65510107 4.98694891,4.65510107 C4.01082286,4.65510107 3.21661627,3.86089448 3.21661627,2.88460926 C3.21661627,1.90848321 4.01082286,1.11411746 4.98694891,1.11411746 M6.85182238,5.08148973 C7.47461404,4.55196562 7.87155817,3.76428458 7.87155817,2.88460926 C7.87155817,1.29412701 6.57743116,0 4.98694891,0 C3.39646666,0 2.10249881,1.29412701 2.10249881,2.88460926 C2.10249881,3.76428458 2.49944294,4.55196562 3.1222346,5.08148973 C1.25290466,5.80869012 4.97379915e-14,7.54941907 4.97379915e-14,9.14642687 C4.97379915e-14,9.5540347 0.156772243,10.5365271 1.60942225,10.8542098 C2.15581728,10.9735795 2.84704759,10.9980901 3.71701417,10.9980901 C3.9124622,10.9980901 4.11491326,10.996976 4.3229349,10.9957027 C4.53859621,10.9945886 4.76062391,10.9933153 4.98694891,10.9933153 C5.23714786,10.9933153 5.4814579,10.9950661 5.71812828,10.9968168 C5.94540824,10.9984084 6.16568518,11 6.37720834,11 C7.21295559,11 7.879357,10.9745345 8.41492917,10.8502308 C9.82205953,10.5236352 9.97405698,9.54989655 9.97405698,9.14642687 C9.97405698,7.54941907 8.72115232,5.80869012 6.85182238,5.08148973",
    id: "Fill-1"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMainEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/main_email.8a0bdafb.svg";
export { ForwardRef as ReactComponent };